
// keys for fields
export const PR_PPT = "PR_PPT";
export const INCOME = 'investment_target';
export const PREMIUM = 'PR_ANNPREM';
export const FREQUENCY = 'INPUT_MODE';
export const SOURCE_OF_PURCHASE_PRICE = 'SOURCE_OF_PP';
export const PRAN_NUMBER = 'PRAN_NUMBER';
export const ANNUITY_BENEFIT = 'AnnuityBenefit';
export const LIFE_STATUS = 'LifeStatus';
export const ANNUITY_MODE = 'AnnuityMode';
export const PURCHASE_PRICE = 'ModalPremium';
export const DEFERMENT_PERIOD = 'DefermentPeriod';
export const ANNUITY_OPTION = 'AnnuityOption';
export const NAME_OF_THE_SECONDARY_ANNUITANT = 'SecondaryAnnuitantName';
export const DOB_NAME_OF_THE_SECONDARY_ANNUITANT = 'SecondaryAnnuitantDateofbirth';
export const THE_SECONDARY_ANNUITANT_DOB = 'SecondaryAnnuitantDOB'
export const  GENDER_NAME_OF_THE_SECONDARY_ANNUITANT = 'SecondaryAnnuitantGender';

export const ACCRUALOFSURVIVALBENEFIT_1 = "AccrualOfSurvivalBenefit_1";
export const ASB_STARTPOLICYYEAR_1 = "ASB_StartPolicyYear_1";
export const ASB_ENDPOLICYYEAR_1 = "ASB_EndPolicyYear_1";

export const ACCRUALOFSURVIVALBENEFIT_2 = "AccrualOfSurvivalBenefit_2";
export const ASB_STARTPOLICYYEAR_2 = "ASB_StartPolicyYear_2";
export const ASB_ENDPOLICYYEAR_2 = "ASB_EndPolicyYear_2";

export const ACCRUALOFSURVIVALBENEFIT_3 = "AccrualOfSurvivalBenefit_3";
export const ASB_STARTPOLICYYEAR_3 = "ASB_StartPolicyYear_3";
export const ASB_ENDPOLICYYEAR_3 = "ASB_EndPolicyYear_3";

export const ASB_WITHDRAWALPERCENTAGE_1 = "WithdrawalPercentage_1";
export const ASB_WITHDRAWALPERCENTAGE_2 = "WithdrawalPercentage_2";
export const ASB_WITHDRAWALPERCENTAGE_3 = "WithdrawalPercentage_3";

